import { SVGProps } from 'react';

import SvgIcon from './lib/SvgIcon';

export const IconLogoSmall = (props: SVGProps<SVGSVGElement>) => {
  return (
    <SvgIcon {...props} viewBox="0 0 15 16">
      <path 
        fill="currentcolor"
        d="M14.8 16h.046L10.392 0H4.454zm-9.975 0a4.83 4.83 0 0 0 4.825-4.837 4.83 4.83 0 0 0-4.825-4.837A4.83 4.83 0 0 0 0 11.163 4.83 4.83 0 0 0 4.825 16"
      />
    </SvgIcon>
  );
};
